import React from 'react'
import * as Auth from '@morningtrain/react-auth'
import { Model, WhenModel, WhenModelValue } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import Smartview from 'widgets/smartviews/Smartview'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import { Link } from '@morningtrain/react-navigation'
import Button from 'ui/buttons/Button'
import ChangeLinkStatus from 'support/actions/ChangeLinkStatus'
import CustomerInfo from 'widgets/smartviews/links/CustomerInfo'

export default function ViewLinkSmartview (props) {
  return (
    <Smartview header='Link'>
      <Model resourceName='links' id={props.id}>

        <WhenModel>
          <WhenModelValue name='dr_publish_link'>
            <SmartviewTextGroup>
              <SmartviewText label='Dr. Publish'>
                <Displays.Link name='dr_publish_link' label='Vis i Dr. Publish' className='btn btn-primary btn-full' />
              </SmartviewText>
            </SmartviewTextGroup>

            <SmartviewContentSeparator />
          </WhenModelValue>

          <SmartviewTextGroup>
            <SmartviewText label='Domænenavn'>
              <Displays.Text name='domain_name' />
            </SmartviewText>
          </SmartviewTextGroup>

          <SmartviewContentSeparator />

          <SmartviewTextGroup>
            <SmartviewText label='Titel'>
              <Displays.Text name='title' />
            </SmartviewText>
          </SmartviewTextGroup>

          <SmartviewContentSeparator />

          <SmartviewTextGroup>
            <SmartviewText label='Udgivelses tidspunkt'>
              <Displays.DateTime name='publish_at' />
            </SmartviewText>
          </SmartviewTextGroup>

          <SmartviewContentSeparator />

          <Auth.Can permission='api.customers.read'>
            <CustomerInfo />

            <SmartviewContentSeparator />
          </Auth.Can>
        </WhenModel>

        <div className='group space-y-4'>
          <Auth.CanUseModel permission='api.links.store'>
            <Link route='app.links.edit' parameters={{ link: props.id }}>
              <Button text='Rediger' width='full' />
            </Link>
          </Auth.CanUseModel>
          <Auth.CanUseModel permission='api.links.store' negate>
            <Link route='app.links.edit' parameters={{ link: props.id }}>
              <Button text='Vis' width='full' />
            </Link>
          </Auth.CanUseModel>
          <ChangeLinkStatus
            operation='submit'
            status='pending_approval'
            label='Send artikel til godkendelse'
          />
          <ChangeLinkStatus
            operation='accept'
            status='pending_publication'
            label='Accepter'
          />
          <ChangeLinkStatus
            operation='reject' status='rejected'
            label='Afvis'
          />
          <ChangeLinkStatus
            operation='publish' status='published'
            label='Udgiv'
          />
        </div>
      </Model>
    </Smartview>
  )
}
